<template>
  <div class="trQuery full-height trQuery-banner">
    <ld-header
      @click-left="back"
      transparent
      white
    >
      <img
        slot="left"
        class="custom-back"
        src="~Assets/images/back.png"
      >
      <trip-type slot="right" v-if="$store.state.app.business"/>
    </ld-header>

    <div
      orient="vertical"
      class="train-query-info full-width text-center white"
    >
      <p class="font20">
        高铁预订
      </p>
      <h3 class="font28">
        快速出票 便携出行
      </h3>
    </div>

    <!-- 查询面板 -->
    <div class="train-index">
      <div class="bg-white round-sm">
        <div class="train-selform">
          <!-- 出差申请单 -->
          <van-row v-if="serviceCtrl.isShowCcsqd">
            <van-col
              span="24"
              class="ccsqd-col"
            >
              <van-cell
                is-link
                :border="false"
                @click.stop="$refs.ccsqdlist.toggle()"
              >
                <template slot="title">
                  <div :class="[ trSearchInfo.Ccsqd.ccsqdNo ? '' : 'gray']">
                    {{ trSearchInfo.Ccsqd.ccsqdNo || $t('K108','请选择出差单') }}
                  </div>
                </template>
                <template
                  v-if="trSearchInfo.Ccsqd.ccsqdNo"
                  slot="default"
                >
                  <div @click.stop="showVoyage = true">
                    <van-tag
                      round
                      plain
                      type="warning"
                      v-show="voyage.arriveCityName"
                    >
                      {{ voyage.departCityName }}-{{ voyage.arriveCityName }}
                    </van-tag>
                    <span v-show="!voyage.arriveCityName && trSearchInfo.Ccsqd.ccsqdNo">选择行程</span>
                  </div>
                </template>
              </van-cell>
            </van-col>
          </van-row>

          <!-- 出行人 -->
          <van-row
            v-if="serviceCtrl.isShowCxr"
            class="train-emp"
          >
            <van-col span="24">
              <div
                class="font16"
                @click="openEmpList"
              >
                <span
                  v-for="(traveler, index) in travelerList"
                  :key="index"
                >
                  {{ traveler | getName }} &nbsp;
                </span>
                <span
                  class="gray"
                  v-show="travelerList.length == 0"
                >
                  {{ $t('I001','请选择出行人') }}
                </span>
              </div>
              <div
                v-if="serviceCtrl.showtips"
                class="tips"
                style="margin-top: 10px;"
              >
                {{ $t('F587','已开启按差标等级管控出差标准，需要先选择出行人') }}
              </div>
            </van-col>
          </van-row>

          <!-- 站点 -->
          <van-row class="train-station font20 font-bold">
            <van-col
              span="10"
              :class="[trSearchInfo.fromStation ? '' : 'gray']"
              @click="serviceCtrl.isChangeVoyage && $refs['fromCity'].toggle()"
            >
              {{ trSearchInfo.fromStation || $t('C104','出发城市') }}
            </van-col>

            <van-col
              class="icon text-center"
              span="4"
              @click="swapCity"
            >
              <ld-icon
                class="main-color"
                size="28"
                type="iconzhuanhuan"
              />
            </van-col>
            <van-col
              class="text-right"
              span="10"
              :class="[trSearchInfo.toStation ? '' : 'gray']"
              @click="serviceCtrl.isChangeVoyage && $refs['toCity'].toggle()"
            >
              {{ trSearchInfo.toStation || $t('C105','到达城市') }}
            </van-col>
          </van-row>

          <!-- 时间 -->
          <van-row class="train-time">
            <van-col
              span="24"
              @click="showDate"
            >
              <span class="font20 font-bold">{{ dateInfo.monDay }}</span> {{ dateInfo.week }}
            </van-col>
          </van-row>

          <van-row class="train-time">
            <van-col span="24">
              <span class="font15">{{ $t('I004','只看高铁动车') }}</span>
              <van-switch
                class="fr"
                v-model="trSearchInfo.needTrainType"
                size="24px"
              />
            </van-col>
          </van-row>

          <!-- 差旅标准 -->
          <div
            v-if="serviceCtrl.isStart && clbzInfo.clbzDesc"
            class="clbz-bar van-ellipsis gray"
            @click="clbzShow = true"
          >
            本次预订使用<span class="main-color">{{ serviceCtrl.showtips ? clbzInfo.minzjName : '' }}</span>的差标：
            <span
              class="main-color"
              v-for="clbz in clbzInfo.clbzDesc"
              :key="clbz.item"
            >
              {{ clbz.item }}
            </span>
          </div>
        </div>

        <div class="query">
          <ld-button
            @click="search"
            size="lg"
            main
          >
            查询车票
          </ld-button>
        </div>
      </div>
    </div>

    <!-- 底部排序tabbar -->
    <van-tabbar safe-area-inset-bottom>
      <van-tabbar-item
        :to="{ path: '/car/carQuery', query: { name: '1' }}"
        v-if="!isXlminiprogram"
      >
        <img
          slot="icon"
          src="~Assets/images/ht/transfer.png"
        >
        <span class="deep-gray">{{ $t('J013','接送站') }}</span>
      </van-tabbar-item>
      <van-tabbar-item @click="toOrderList">
        <img
          slot="icon"
          src="~Assets/images/ht/myOrder.png"
        >
        <span class="deep-gray">{{ $t('A010','火车票') }}{{ $t('Order','订单') }}</span>
      </van-tabbar-item>
    </van-tabbar>

    <!-- 选择出行人控件 -->
    <ld-emp-list
      ref="empList"
      :cplx="CPLX"
      :person-list="trSearchInfo.Ccsqd.personList"
      @selected="empSelect"
    />

    <!-- 差旅标准 -->
    <van-popup
      v-model="clbzShow"
      class="clbz-popup"
      :close-on-popstate="true"
      :style="{ width: '80%', maxHeight: '60%' }"
    >
      <h3 class="text-center">
        差旅标准
      </h3>
      <van-row class="clbz-value">
        <p
          class="mt5"
          v-for="(clbz, i) in clbzInfo.clbzDesc"
          :key="i"
        >
          {{ i + 1 }}.{{ clbz.item }}
        </p>
      </van-row>
      <ld-button
        @click="clbzShow = false"
        size="lg"
        main3
      >
        我知道了
      </ld-button>
    </van-popup>

    <!-- 日历 -->
    <!-- <ld-date
      ref="date"
      @selected="dateSelect"
      :date="trSearchInfo.byTrainDate"
      :min-date="trSearchInfo.MIN_DATE"
      :max-date="trSearchInfo.MAX_DATE"
    /> -->
    <Ld-calendar
      ref="date"
      @selected="getDate"
      :mi0="than15"
    />
    <!-- 出发城市 -->
    <city
      ref="fromCity"
      @selected="fromCitySelect"
      placeholder="请输入城市/站点名"
      cplx="10904"
      :city-type="2"
      v-if="showCity"
    />

    <!-- 到达城市 -->
    <city
      ref="toCity"
      @selected="toCitySelect"
      placeholder="请输入城市/站点名"
      cplx="10904"
      :city-type="2"
      v-if="showCity"
    />

    <!-- 出差申请单 -->
    <ld-check-list
      ref="ccsqdlist"
      type="4"
      :params="params"
      @selected="ccsqdSelect"
    />

    <!-- 行程列表 -->
    <van-popup
      v-if="trSearchInfo.Ccsqd.routeBookList"
      v-model="showVoyage"
      position="bottom"
      :close-on-popstate="true"
    >
      <div class="route-item">
        <van-tag
          round
          plain
          type="warning"
          size="large"
          v-for="(info, index) in trSearchInfo.Ccsqd.routeBookList"
          :key="index"
          @click="changeVoyage(index)"
        >
          {{ info.departCityName || info.departAirportName }}-{{ info.arriveCityName || info.arriveAirportName }} &nbsp;
        </van-tag>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Switch, NoticeBar, Popup, Tabbar, TabbarItem, Cell, Tag } from 'vant'
import { mapGetters,mapActions } from 'vuex'
import { formatDate } from 'Utils/dateUtil'
import ldButton from 'Common/ldButton'
import tripType from 'Common/tripType'
import City from 'Common/city'
import ldCheckList from 'Components/ldCheckList'
import TrainBookInteractor from 'Domain/use-cases/train-book-interactor'
import defaultMixin from '../../../mixins/default'
import thirdLogin from "@/business/mixins/thirdLogin";
import {isXlminp, goXlHome} from 'Utils/xltools'
import {goYxHome, isYx} from "Utils/yxtools";


const CPLX = $dict.PRO_TYPE.tr

export default {
  name: 'TrQuery',
  mixins:[defaultMixin, thirdLogin],
  components: {
    [NoticeBar.name]: NoticeBar,
    [Switch.name]: Switch,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Popup.name]: Popup,
    [Cell.name]: Cell,
    [Tag.name]: Tag,
    ldButton,	tripType,	City, ldCheckList,
    ldEmpList: () => import('Components/ldEmpList/index.vue'),
    LdCalendar: () => import('Common/ldCalendar'),
  },
  data () {
    return {
      CPLX,
      clbzInfo: {}, // 差旅标准
      clbzShow: false,
      showVoyage: false,
      voyage:{}, // 当前选中行程
      params:{ 'cplx': CPLX },
      showCity: false,
    }
  },
  async created () {
    await this.auth()
    // 因为city组件里面调用了需要token的接口，所以需要在这里延时加载组件
    this.showCity = true
    /**
     * 日期选择范围计算
     */
    this.$store.commit('SET_SERVICE', { cplx: this.CPLX })
    this.$store.commit('tr/CLEAR_TRSEARCHINFO')

    /**
     * 开启默认为自己订票参数 且 不是出差申请单模式下
     */
    if(this.serviceCtrl.isShowCcsqd){
      let ccsqdId = this.$route.query.ccsqdId
      if(ccsqdId){
        this.$api['common/vipCcsqdGetListForChoose']({
          ccsqdId:ccsqdId,
          proType:this.CPLX
        }).then(res=>{
          var cache=res.data||[]
          if(cache.length>0){
            this.ccsqdSelect(cache[0])
          }else{
            this.$toast('未查询到申请单信息')
          }
        })
      }
    }else if (this.serviceCtrl.isDefaultName) {
      this.travelerList.push({...this.userInfo.empInfo, clkFlag: 2})
      this.empSelect()
    }
    /**
     * 若是按公司统一标准 不选人就匹配差旅标准
     */
    // else if (!this.serviceCtrl.showtips) {
    // 	this.empSelect()
    // }

    /**
     * 单订模式，默认获取上一次查询站点
     */
    if (!this.serviceCtrl.isShowCcsqd) {
      this.historyLog()
    }
    this.$store.dispatch('tr/getPageParameter')
    this.getBusiness()
  },
  methods: {
    ...mapActions(['getBusiness']),
    historyLog(){
      TrainBookInteractor.getPrevStation().then(item => {
        const { fromStation, fromStationCode, toStation, toStationCode, byTrainDate } = item
        this.trSearchInfo.fromStation = fromStation
        this.trSearchInfo.fromStationCode = fromStationCode
        this.trSearchInfo.toStation = toStation
        this.trSearchInfo.toStationCode = toStationCode
        this.trSearchInfo.byTrainDate = byTrainDate
        this.$store.commit('tr/trSearchInfo',this.trSearchInfo)
      })
    },
    openEmpList () {
      if (this.serviceCtrl.isShowCcsqd && !this.trSearchInfo.Ccsqd.ccsqdId) {
        this.$toast('请选择出差申请单')
      } else {
        this.$refs['empList'].toggle({index:1})
      }
    },
    async empSelect () {
      if (this.serviceCtrl.isStart) {
        const { minzjName, minzj } = this.serviceCtrl.getClbzMinZj(this.travelerList)
        this.clbzInfo.minzjName = minzjName
        this.trSearchInfo.minRank = minzj

        const { data } = await TrainBookInteractor.getTravelPolicyDetail(this.trSearchInfo.minRank)
        this.$set(this.clbzInfo, 'clbzDesc', data)
        this.trSearchInfo.violateCode = data.violateCode
      }
    },
    showDate(){
      if(this.serviceCtrl.isChangeDate){
        this.$refs.date.toggle({
          defaultDate:this.trSearchInfo.byTrainDate,
          minDate:this.trSearchInfo.MIN_DATE,
          maxDate:this.trSearchInfo.MAX_DATE
        })
      }
    },
    getDate(date) {
      this.trSearchInfo.byTrainDate = date
    },
    /**
     * 选择出发城市
     */
    fromCitySelect(city) {
      this.trSearchInfo.fromStation = city.jcZdName || city.cityName
      this.trSearchInfo.fromStationCode = city.jcZdCode || city.threeCode
      this.trSearchInfo.fromStationCityId = city.cityId
    },
    /**
     * 选择到达城市
     */
    toCitySelect(city) {
      this.trSearchInfo.toStation = city.jcZdName || city.cityName
      this.trSearchInfo.toStationCode = city.jcZdCode || city.threeCode
      this.trSearchInfo.toStationCityId = city.cityId
    },
    /**
     * 交换出发到达城市
     */
    swapCity () {
      [this.trSearchInfo.fromStation, this.trSearchInfo.fromStationCode, this.trSearchInfo.toStation, this.trSearchInfo.toStationCode] =
      [this.trSearchInfo.toStation, this.trSearchInfo.toStationCode, this.trSearchInfo.fromStation, this.trSearchInfo.fromStationCode]
    },
    /**
     * 选择出差申请单
     */
    ccsqdSelect (info) {
      this.trSearchInfo.Ccsqd = info
      // 默认选择第一个行程
      this.changeVoyage(0)
    },
    toOrderList () {
      this.$store.commit('SET_ORDERLISTPARAMS', {
        findType: 1,
        productType: CPLX
      })
      this.$router.push('/allOrder?findType=1')
    },
    //选择行程信息
    changeVoyage (index) {
      let routeList = this.trSearchInfo.Ccsqd.routeBookList || []
      if(routeList.length > 0) {


        if (this.$route.query.routeId != null && this.$route.query.routeId != undefined) {
          routeList.forEach(o => {
            if (this.$route.query.routeId == o.routeId) {
              this.voyage = o
            }
          })
        } else {
          this.voyage = routeList[index]
        }


        try {
          TrainBookInteractor.voyageValid(this.voyage)

          const data = TrainBookInteractor.voyageInfoTranslator(this.trSearchInfo.Ccsqd, this.voyage, this.serviceCtrl.isChangeDateRange)
          this.$store.commit('tr/travelerList', data.travelerList)
          this.empSelect()
          delete data.travelerList
          Object.assign(this.trSearchInfo, data)

          this.showVoyage = false
        } catch (error) {
          if (error.type === 'confirm') {
            this.$dialog.confirm({
              message: error.errMessage
            }).then(() => {
              const data = TrainBookInteractor.voyageInfoTranslator(this.trSearchInfo.Ccsqd, this.voyage, this.serviceCtrl.isChangeDateRange)
              this.$store.commit('tr/travelerList', data.travelerList)
              this.empSelect()
              delete data.travelerList
              Object.assign(this.trSearchInfo, data)
            })
          }
        }

      }else{
        this.$toast('当前出差申请单无行程')
      }
    },
    search () { 
      if(localStorage.getItem("home")){
        localStorage.removeItem('home');
      }

      try {
        TrainBookInteractor.validSearchParams(this.trSearchInfo, this.serviceCtrl, this.travelerList)

        this.trSearchInfo.tripType = this.tripType
        this.trSearchInfo.trainList = []
        // this.$router.push('/tr/trList')
        this.$router.push({
          path: '/tr/trList',
          query: {
            ccsqdId: this.$route.query.ccsqdId,
            routeId: this.$route.query.routeId
          }
        })
      } catch (err) {
        this.$toast(err)
      }
    },
    back(){
      if (isXlminp()) {
        return goXlHome()
      }
      if (isYx()) {
        return goYxHome()
      }
      this.$router.push('/home')
    }
  },
  computed: {
    ...mapGetters({
      trSearchInfo: 'tr/trSearchInfo',
      travelerList: 'tr/travelerList',
      tripType: 'tripType',
      userInfo: 'userInfo',
      serviceCtrl: 'serviceCtrl',
    }),
    dateInfo: vm => formatDate(vm.trSearchInfo.byTrainDate),
    than15(){
      return formatDate(new Date().setDate( new Date().getDate() + 14)).date
    }
  },
  watch: {
    trSearchInfo: {
      handler (val) {
        if (!this.serviceCtrl.isShowCcsqd) {
          TrainBookInteractor.setPrevStation(val)
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="less">
@import "~Assets/styles/business.less";

.trQuery {
  background-repeat: no-repeat;
  background-size: 114% 126%;
  background-position: top;

  p, h3 {
    margin: 0;
  }

  .train-query-info {
    position: fixed;
    top: 25%;
  }

  .train-index {
     position: absolute;
    bottom: 60px;
    padding: 0 12px;
    width: 100%;
    .train-selform {
      padding: 0px 16px;

      .van-row {
        .van-col {
          padding: 12px 0;
          border-bottom: 1px solid @color-background-gray;
        }

        .van-col.icon {
          font-family: @font-bold-lg;
          border-bottom: none;
        }

        .ccsqd-col {
          padding: 0;

          .van-cell {
            padding: 15px 0;
          }
        }
      }

    }
  }

  .query {
    padding: 20px 24px;
  }

  .clbz-popup {
    width: 80%;
    padding: 20px 53px;

    h3 {
      margin-bottom: 15px;
    }
    p {
      margin-top: 5px;
    }

    .clbz-value {
      min-height: 180px;
    }
  }

  .route-item {
    padding: 16px;

    .van-tag {
      margin-left: 5px;
    }
  }
}
</style>
